export const apiURL = process.env.API_URL;
export const baseURL = process.env.BASE_URL;
export const host = process.env.HOST;
export const stripePublicKey = process.env.STRIPE_PUBLIC_KEY;
export const imageBaseURL = process.env.IMG_BASE_URL;
export const xFunctionsKey = process.env.X_FUNCTIONS_KEY;
export const swishApiUrl = process.env.SWISH_API_URL;
export const vourityMapsApiKey = process.env.VOURITY_MAPS_API_KEY;
export const sentryUrl = process.env.SENTRY_API_URL;
export const accessWebUrl = process.env.ACCESS_WEB_URL;
export const quickshopWebUrl = process.env.QUICKSHOP_WEB_URL;
export const ocpApimSubscriptionKey = process.env.OCP_APIM_SUBSCRIPTION_KEY;
export const webShopUrl = process.env.WEBSHOP_URL;
export const syncfusionLicenseKey = process.env.SYNCFUSION_LICENSE_KEY;
